import * as React from 'react';
import './radio.scss';

interface Props {
  checked: (name: string, value: string) => void;
  text?: string;
  radioName: string;
  value?: string;
  isChecked?: boolean;
  containerStyle?: React.CSSProperties;
  circleStyle?: React.CSSProperties;
}

const RadioButton: React.FC<Props> = ({ checked, text, radioName, value, isChecked, containerStyle, circleStyle }) => {
  const onClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    checked(event.target.name, event.target.value);
  };
  return (
    <>
      <label className="radio-button" style={containerStyle}>
        <input type="radio" name={radioName} onChange={onClick} value={value} checked={isChecked} style={circleStyle} />
        <span className="radio-button__checkmark"></span>
        <div className="radio-button__itemText"> {text} </div>
      </label>
    </>
  );
};
export default RadioButton;
